import { useNavigate } from "react-router-dom";
import "../css/receipt.css";
import graphics from "../media/purchase.png";
import useFirebaseStore from "../store/firebasestore";

function Checkoutreceipt() {
    const userName = useFirebaseStore(
        (s) => s.userName
    );

    const authStatus = useFirebaseStore(
        (s) => s.authStatus
    );

    const navigate = useNavigate();

    const receiptName =
        localStorage.getItem("receiptName") || "";

    const receiptDestination =
        localStorage.getItem(
            "receiptDestination"
        ) || "";

    const receiptPhone =
        localStorage.getItem("receiptPhone") || "";

    const receiptAmount =
        localStorage.getItem("receiptAmount") || "0";

    const receiptTransaction =
        localStorage.getItem(
            "receiptTransaction"
        ) || "";

    const params = new URLSearchParams(
        window.location.search
    );

    const trxref =
        params.get("trxref") ||
        receiptTransaction;

    const customerName =
        receiptName ||
        (
            authStatus === "authenticated"
                ? userName
                : "Guest Customer"
        ) ||
        "Customer";

    const amountPaid = Number(
        receiptAmount
    ).toLocaleString("en-KE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const destination =
        receiptDestination ||
        "Not provided";

    const phone =
        receiptPhone ||
        "Not provided";

    return (
        <div className="checkoutreceiptWrap">

            <div className="crWCard">

                <div className="crwCardTop">

                    <img
                        src={graphics}
                        alt=""
                    />

                    <p>
                        Thank you for your purchase!
                    </p>

                </div>

                <div className="crwCardBtm">

                    <div className="crwCardBtmCard">

                        <div className="crwCardBtmCardRow">
                            <p>
                                {customerName}
                            </p>

                            <span>
                                Customer
                            </span>
                        </div>

                        <div className="crwCardBtmCardRow">
                            <p>
                                {destination}
                            </p>

                            <span>
                                Destination
                            </span>
                        </div>

                        <div className="crwCardBtmCardRow">
                            <p>
                                Ksh. {amountPaid}
                            </p>

                            <span>
                                Amount Paid
                            </span>
                        </div>

                        <div className="crwCardBtmCardRow">
                            <p>
                                {phone}
                            </p>

                            <span>
                                Phone
                            </span>
                        </div>

                        <div className="crwCardBtmCardRowBtn">

                            <button
                                onClick={() =>
                                    navigate("/")
                                }
                            >
                                Done
                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default Checkoutreceipt;